module.exports = __webpack_public_path__ + "img/7s.aaa105a5.png";